import { execute } from '@/api/execute'
import { addQueryParams } from '@/util/index.js'
import { GET, POST, PUT, DELETE } from '@/api/types'

const ENDPOINT = 'manager/companies'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  }
}
